import config from "../config"
import VueCookies from 'vue-cookies'
const dateTranslate = {
  /**
   * 日期 转换为 Unix时间戳
   * @param <string> 2014-01-01 20:20:20  日期格式
   * @return   unix时间戳(秒)
   */
  DateToUnix: function(string) {
    let f = string.split(' ', 2);
    let d = (f[0] ? f[0] : '').split('-', 3);
    let t = (f[1] ? f[1] : '').split(':', 3);
    return (new Date(
      parseInt(d[0], 10) || null,
      (parseInt(d[1], 10) || 1) - 1,
      parseInt(d[2], 10) || null,
      parseInt(t[0], 10) || null,
      parseInt(t[1], 10) || null,
      parseInt(t[2], 10) || null
    )).getTime() / 1000;
  },
  /**
   * 时间戳转换日期
   * @param <int> unixTime    待时间戳(秒)
   * @param <bool> isFull    返回完整时间(Y-m-d 或者 Y-m-d H:i:s)
   * @param <int>  timeZone   时区
   */
  UnixToDate: function UnixToDate(unixTime, isFull, timeZone) {
    if (typeof (timeZone) == 'number') {
      unixTime = parseInt(unixTime) + parseInt(timeZone) * 60 * 60;
    }
    let time = new Date(unixTime * 1000);
    let ymdhis = '';
    ymdhis += time.getUTCFullYear() + '-';
    ymdhis += (time.getUTCMonth() + 1) + '-';
    ymdhis += time.getUTCDate();
    if (isFull === true) {
      ymdhis += ' ' + time.getUTCHours() + ':';
      ymdhis += time.getUTCMinutes() + ':';
      ymdhis += time.getUTCSeconds();
    }
    return ymdhis;
  }
};
export default dateTranslate;
export function setCookie(name,value,iDay){//设置cookie
    VueCookies.set(name,value,iDay, config.cookie.path, config.cookie.domain)
}
export function getCookie(name){//获取cookie
  return VueCookies.isKey(name) ? VueCookies.get(name) : null;
}
export function removeCookie(name){ //删除cookie
    VueCookies.remove(name);
}
export function getSession(){
  const user = getCookie(config.cookie.flag.member+'_'+config.schemaId);
  return user?user.session:'';
}
export function setUser(obj){
    setCookie(config.cookie.flag.member+'_'+config.schemaId,
                                  {'session':obj.sess,
                                      'memberId':obj.memberId
                                  },
                                  config.cookie.expires
                              );
}
export function getUser(){
    return getCookie(config.cookie.flag.member+'_'+config.schemaId);
}
export function setKeeLogin(value){
    setCookie("isKeeAutoLogin",value,config.cookie.expires)
}
